// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1wkiM","amount":"Amount_amount__1I5pN","tip":"Amount_tip__31BjC","tipHeader":"Amount_tipHeader__16bdX","tipsWrap":"Amount_tipsWrap__QJ8f7"};